module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/mainvisual-title-pc_e8e3d85464330f2a5f711ac6e9bc869e.png";